import { useState } from 'react';
import PropTypes from 'prop-types';
import { useConfiguredBrandsQuery } from '../../queries/brandMetrics';
import { useMediaPlanningQuery } from '../../queries/mediaPlanning';
import MediaPlanningGrid from './MediaPlanningGrid';

const currentMonth = () => new Date().toISOString().slice(0, 7);

const controlCls =
  'rounded-lg border border-gray-300 bg-white px-2.5 py-1.5 text-sm text-gray-700';

function Notice({ children, onRetry }) {
  return (
    <div className="rounded-card border border-gray-200 bg-white p-10 text-center text-sm text-gray-500 shadow-card">
      {children}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="ml-2 font-medium text-primary underline-offset-2 hover:underline"
        >
          Reintentar
        </button>
      )}
    </div>
  );
}

Notice.propTypes = {
  children: PropTypes.node,
  onRetry: PropTypes.func,
};

/**
 * Vista admin de Media Planning (F0, read-only): elegí marca + mes y la grilla
 * muestra presupuestado / deberíamos / real por día. No modifica presupuestos.
 */
export default function MediaPlanningPage() {
  const { data: brands = [] } = useConfiguredBrandsQuery();
  const [brandId, setBrandId] = useState(null);
  const [month, setMonth] = useState(currentMonth);

  const { data: plan, isLoading, isError, refetch } = useMediaPlanningQuery(brandId, month);
  const selectedBrand = brands.find((b) => b.id === brandId);

  return (
    <div className="mx-auto max-w-[110rem] space-y-6 p-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-xl font-bold text-gray-900">Media planning</h1>
          <p className="text-sm text-gray-500">
            Grilla read-only: presupuestado vs. deberíamos vs. real por día. No modifica presupuestos.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <select
            aria-label="Marca"
            className={controlCls}
            value={brandId ?? ''}
            onChange={(e) => setBrandId(e.target.value ? Number(e.target.value) : null)}
          >
            <option value="">Elegí una marca</option>
            {brands.map((b) => (
              <option key={b.id} value={b.id}>
                {b.name}
              </option>
            ))}
          </select>
          <input
            aria-label="Mes"
            type="month"
            className={controlCls}
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          />
        </div>
      </div>

      {!brandId ? (
        <Notice>Elegí una marca para ver su planificación.</Notice>
      ) : isLoading ? (
        <Notice>Cargando planificación…</Notice>
      ) : isError ? (
        <Notice onRetry={refetch}>No se pudo cargar la planificación.</Notice>
      ) : (
        <MediaPlanningGrid plan={plan} brandName={selectedBrand?.name} />
      )}
    </div>
  );
}
